import { createSelector } from 'reselect';

/**
 * Memoized selector that combines all Card Usage Options Form data.
 * Prevents unnecessary re-renders by only updating when actual data changes.
 */
export const selectCardUsageOptionsFormContext = createSelector(
  [
    (state: any) => state.userStore,
    (state: any) => state.accountDefaults,
    (state: any) => state.getCardOptions,
    (state: any) => state.getVehicleTypes,
    (state: any) => state.createCardOptions,
    (state: any) => state.updateCardOptions,
    (state: any) => state.modalStore,
  ],
  (userStore, accountDefaults, getCardOptions, getVehicleTypes, createCardOptions, updateCardOptions, modalStore) => ({
    // User context
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    canReadWrite: userStore.canReadWriteAccounts,

    // Account defaults
    accountDefaults: accountDefaults.result,
    accountDefaultsLoading: accountDefaults.isLoading,

    // Card options
    cardOptionDetails: getCardOptions.cardOptions,
    cardOptions: getCardOptions.cardOptions.profiles || [],
    cardOptionsLoading: getCardOptions.isLoading,

    // Vehicle types
    vehicleTypes: getVehicleTypes.vehicleTypes,

    // Action completion flags
    createCardOptionSuccess: createCardOptions.isSuccess,
    updateCardOptionSuccess: updateCardOptions.isSuccess,

    // Modal state
    primaryActionButton: modalStore.primaryActionButton,
  })
);
